import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { View } from 'foundations-components/components/View';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
const NotFoundError = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "notFound",
    title: unescapedText('appMarketplace.error.notFound.title'),
    children: /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        use: "tertiary",
        to: "/",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.error.notFound.button"
        })
      })
    })
  });
};
export default NotFoundError;